module.exports = __webpack_public_path__ + "static/img/kf.fb7e694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kf.png
// module id = ccpG
// module chunks = 1